$(document).ready(function () {
    // slider-with-change-on-hover
    $('.js-slider-with-change-on-hover').each(function (i, slider) {
        new SliderWithChangeOnHover($(slider));
    });
})
